




























import { Component, Prop, Vue } from 'vue-property-decorator';
import Container from '@/components/atoms/Grid/Container.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import eventBus from '@/utils/eventBus';

@Component({
  components: {
    FilledButton,
    FormLabel,
    Container,
    Typography
  }
})
export default class CoinStoreDealConfirmModal extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly subtitle!: string;
  @Prop() readonly onConfirm!: any;

  loading = false;

  async confirm() {
    try {
      this.loading = true;

      if (this.onConfirm) await this.onConfirm();
    } finally {
      this.loading = false;
    }
  }

  closeModal() {
    eventBus.$emit('closeModal');
  }
}
